import { createContext, useState} from "react";
import { useNavigate
// , Location, Link
 } from 'react-router-dom';
import axios from '../api/DataTrans';
// import io from 'socket.io-client';
// import {io} from 'socket.io-client';

const DataContext = createContext({});
export const DataProvider = ({ children }) => {
  const navigate = useNavigate();
  const [token,setToken] = useState('');
  const [lang,setLang] = useState(false);
  const [where,setWhere] = useState('Home');
  const [firstName,setFirstName] = useState('');
  const [lastName,setLastName] = useState('');
  const [fatherName,setFatherName] = useState('');
  const [motherName,setMotherName] = useState('');
  const [phoneNumber,setPhoneNumber] = useState('');
  const [gender,setGender] = useState('');
  const [ iss ,setIss] = useState('');
  const [userProfile,setUserProfile] = useState([]);
  const [selectedTrip,setSelectedTrip] = useState({});

  const [price,setPrice] = useState(0);
  const [selectedChears,setSelectedChears] = useState([]);
  const [chears,setChears] = useState([]);
  // const socket = io.connect("https://way-go.vercel.app/");
  const [socketChears,SetSocketChears] = useState([]);

  // const socket = io("https://way-go.vercel.app/");
  // socket.on('connect',() => {
  //   console.log(`you connected with ${socket.id}`)
  // })

  // socket.on("chearsStatus",(chear)=>{
  //   console.log(chear)
  //   console.log('chear hi hi')

  //   SetSocketChears(chear);
  // })
  // useEffect(()=>{
  //   socket.on("chearsStatus",(chear)=>{
  //     console.log(chear)
  //     SetSocketChears(chear);
  //   })
  // },[socket,SetSocketChears]);
  // console.log(socketChears);
  const singup = async (e) => {
    e.preventDefault();
    try{
        const response = await axios.post('/customer/register',{
            'firstName':firstName,
            'lastName':lastName,
            'fatherName':fatherName,
            'motherName':motherName,
            'phoneNumber':phoneNumber,
            "gender":gender,
            "iss":iss
          },
          {
            headers:{
              'Content-Type' : 'application/json'
            },
          },
          );
          alert(lang?'تم ارسال إنشاء الحساب بنجاح بنجاح':'now you have an account');
          setToken(response.data.token);
          setUserProfile(response.data.profile);
          console.log(response);
          navigate('/login');
          setFirstName('');
          setLastName('');
          setFatherName('');
          setMotherName('');
          setGender('');
          setIss('');
          setPhoneNumber('');
    }
    catch(err){
        console.log(err);
    }
}
const checkchears = async () => {
  try{
    console.log(selectedTrip?.id);
    console.log(selectedChears);
    console.log(token);


      const response = await axios.post('/customer/bookChear',{
          'tripId':`${selectedTrip?.id.toString()}`,
          'chear':selectedChears,
        },
        {
          headers:{
            'Authorization':token,
            'Content-Type' : 'application/json'
          },
        },
        );
        alert(lang?'تم ارسال المقاعد بنجاح بنجاح':'now you have an account');
        console.log(response);
        // navigate('/login');
  }
  catch(err){
      console.log(err);
  }
}
  // useEffect(()=>{
  //   setLang(localStorage?.getItem('lang'));
  // },[lang]);

    return(
        <DataContext.Provider value={{
          lang,setLang,where,setWhere,token,userProfile,setUserProfile,setToken,
          firstName,lastName,fatherName,motherName,phoneNumber,gender,iss,
          setFirstName,setLastName,setFatherName,setMotherName,setPhoneNumber,setGender,setIss,singup,
          selectedTrip,setSelectedTrip,
          selectedChears,setSelectedChears,price,setPrice,chears,setChears,checkchears
          ,socketChears,SetSocketChears
        }}>
            {children}
        </DataContext.Provider>
    )
}
export default DataContext;
// moaz ==»» {
//   "email":"yaser@waygo"     ,
//   "password":"@yaser@"  ,
//   "firstName":"yaser" ,
//   "lastName": "alsamsam" ,
//   "phone":  "0991810721"   ,
//   "accountType":"admin"
//   }  هي حساب لمعاذ مشان يبلش شغل